/**
* DevExpress HTML/JS Reporting (designer\tools\smartTags\expressionSmartTag.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Disposable } from '@devexpress/analytics-core/analytics-utils';
import * as ko from 'knockout';
import { ReportExpressionEditorWrapper } from '../../widgets/expressioneditor/reportExpressionEditorWrapper';
export class ExpressionSmartTag extends Disposable {
    constructor(reportElement, _expressionEditor) {
        super();
        this.reportElement = reportElement;
        this._expressionEditor = _expressionEditor;
        this.imageTemplateName = 'dxrd-svg-properties-propertyexpression';
    }
    onClick() {
        var expressionEditor = new ReportExpressionEditorWrapper(ko.observable(this.reportElement), ko.observable(null));
        this._expressionEditor(expressionEditor);
        this._expressionEditor().popupVisible(true);
        var subpscription = expressionEditor.popupVisible.subscribe((newVal) => {
            if (!newVal) {
                subpscription.dispose();
                expressionEditor.dispose();
                this._expressionEditor(null);
            }
        });
    }
}
